import type { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { buildAssetsPath } from '@/libs/helpers/assets'
import { Grid } from '@/tbui'

export enum EmptySearchResultVariant {
  RESTAURANT_AROUND = 'RESTAURANT_AROUND',
  RESTAURANT = 'RESTAURANT',
  ADDRESS = 'ADDRESS',
}

const StyledImage = styled.img`
  max-width: 100%;
  margin: 0 auto;
  height: auto;
`

const StyledTitle = styled.h2`
  font-family: ${(props) => props.theme.font.FAMILY_BOLD};
  letter-spacing: 0.6px;
  text-align: center;
  margin-bottom: 0;
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'fontSize',
      fromSize: '18px',
      toSize: '30px',
    })}
`

const StyledMessage = styled.p`
  font-family: ${(props) => props.theme.font.FAMILY};
  letter-spacing: 0.48px;
  text-align: center;
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'fontSize',
      fromSize: '14px',
      toSize: '24px',
    })};
`

const EmptySearchResult: FunctionComponent<{
  variant: EmptySearchResultVariant
}> = ({ variant }) => {
  const { t } = useTranslation()

  const imageSrcMap = {
    [EmptySearchResultVariant.ADDRESS]: buildAssetsPath('/images/no-address.png'),
    [EmptySearchResultVariant.RESTAURANT]: buildAssetsPath('/images/no-restaurants.png'),
    [EmptySearchResultVariant.RESTAURANT_AROUND]: buildAssetsPath('/images/no-restaurants.png'),
  }

  return (
    <Grid p="40px 24px">
      <StyledImage
        alt={t('tbdine.empty_search_results.title', { context: variant })}
        src={imageSrcMap[variant]}
      />
      <StyledTitle>{t('tbdine.empty_search_results.title', { context: variant })}</StyledTitle>
      <StyledMessage>
        {t('tbdine.empty_search_results.message', { context: variant })}
      </StyledMessage>
    </Grid>
  )
}

export default EmptySearchResult
